import { useHistory } from 'react-router-dom'
import { useAppParamsContext } from '../../../context/AppParamsContext'
import { IconArrowLeft } from '../../../assets/icons'
import bgHeaderTamove from '../../../assets/images/bgHeader.png'
import './index.scss'

const HEADER_PARTNER_CONFIG = {
  TAMOVE: {
    iconBack: IconArrowLeft,
    headerClass: 'HeaderPartner--tamove',
    backgroundValue: `url(${bgHeaderTamove})`,
    isAlwaysBlendHeaderWithBody: false
  },
  BIDV: {
    iconBack: IconArrowLeft,
    headerClass: 'HeaderPartner--bidv',
    backgroundValue: 'linear-gradient(180deg, rgba(166, 205, 204, 0.9) 0%, #F0F5F5 40%)',
    isAlwaysBlendHeaderWithBody: true
  },
  TAXACDS: {
    iconBack: IconArrowLeft,
    headerClass: 'HeaderPartner--taxacds',
    backgroundValue: 'var(--brand-primary, #cc0001)',
    isAlwaysBlendHeaderWithBody: false
  }
}

export default function LayoutPartner({ 
  children, 
  headerTitle, 
  scrollableTitle,
  noHeader = false, 
  blendHeaderWithBody = false, 
  onGoBack 
}) {
  const history = useHistory()
  const { isEmbeddedView, appThemeName } = useAppParamsContext()

  // Resolve config based on theme, fallback to TAMOVE
  const themeConfig = HEADER_PARTNER_CONFIG[appThemeName] || HEADER_PARTNER_CONFIG.TAMOVE
  
  const { 
    iconBack: IconBack, 
    headerClass, 
    backgroundValue, 
    isAlwaysBlendHeaderWithBody 
  } = themeConfig

  const hideHeader = isEmbeddedView || noHeader

  // Quyết định xem có kéo background từ header xuống body hay không
  // Nếu config cứng là isAlwaysBlendHeaderWithBody = true, luôn luôn kéo
  // Nếu không, phụ thuộc vào prop blendHeaderWithBody truyền từ từng trang
  const finalBlendBg = isAlwaysBlendHeaderWithBody || blendHeaderWithBody

  return (
    <div id="LayoutPartner" className={finalBlendBg ? 'LayoutPartner--blend-header' : ''}>
      {/* Background body (kéo dài 500px xuống content) - chỉ hiển thị nếu finalBlendBg = true */}
      {finalBlendBg && (
        <div className="LayoutPartner_blend_bg" style={{ background: backgroundValue }} />
      )}

      {!hideHeader && (
        // Nếu không finalBlendBg, ta thêm class để giới hạn nội dung
        <div className={`HeaderPartner ${headerClass} ${!finalBlendBg ? 'HeaderPartner--contained-bg' : ''}`}>
          <div className="HeaderPartner_fixed">
            {backgroundValue && (
              <div className="HeaderPartner_fixed_bg_wrapper">
                <div
                  className="HeaderPartner_fixed_bg"
                  style={{ background: backgroundValue }}
                />
              </div>
            )}

            <div className="HeaderPartner_fixed_content">
              <div className="HeaderPartner_fixed_content_left" onClick={() => {
                if (onGoBack) {
                  onGoBack()
                } else {
                  history.goBack()
                }
              }}>
                {IconBack && <IconBack />}
              </div>
              <div className="HeaderPartner_fixed_content_title">
                {headerTitle}
              </div>
              <div className="HeaderPartner_fixed_content_right"></div>
            </div>
          </div>
          <div className="HeaderPartner_padding"></div>
        </div>
      )}

      {/* Text cuộn theo body (Large Title) */}
      {scrollableTitle && !hideHeader && (
        <div className={`LayoutPartner_scrollable_title ${headerClass}`}>
          {scrollableTitle}
        </div>
      )}
      
      <div className="LayoutPartner_children">{children}</div>
    </div>
  )
}
